// DO NOT CHANGE THE EXISTING VALUES. You can add new values, but you cannot change the existing values.
export enum IntegrationKind {
  Test = "test",
  Klaviyo = "klaviyo",
  Dsco = "dsco",
  Judgeme = "judgeme",
  LoyaltyLion = "loyalty-lion",
  Attentive = "attentive",
  Postscript = "postscript",
  Loop = "loop",
  Yotpo = "yotpo",
  QuickBooksOnline = "quickbooks-online",
  Stripe = "stripe",
  GoogleAnalytics = "google-analytics",
}
